var SCM = SCM || {};

SCM.JwPlayer = (function ($) {
    var JwPlayerDivSelector = '.jwplayer-placeholder[data-media-url]';

    return {
        init: _init
    };

    function _init() {
        if (!_jwPlayerIsEnabled() || !_pageContainsJwPlayerPlaceholders()) {
            return;
        }

        $(JwPlayerDivSelector).each(function (index, elem) {
            _initializeJwPlayer($(elem));
        });
    }

    function _jwPlayerIsEnabled() {
        return !!window.jwplayer;
    }

    function _pageContainsJwPlayerPlaceholders() {
        return !!$(JwPlayerDivSelector).length;
    }

    function _initializeJwPlayer($placeholder) {
        var mediaUrl = $placeholder.data('mediaUrl');
        if (!mediaUrl) {
            return;
        }

        var placeholderId = $placeholder.attr('id');
        if (!placeholderId) {
            placeholderId = _generateReasonablyUniqueId();
            $placeholder.attr('id', placeholderId);
        }
        window.jwplayer(placeholderId).setup({
            file: mediaUrl
        });
    }

    function _generateReasonablyUniqueId() {
        return 'xxxx-xxxx-xxxx-xxxx'.replace(/x/g,
            function() {
                return (Math.random() * 16 | 0).toString(16);
            });
    }

})(jQuery);
